import { Component } from '@angular/core';

@Component({
  selector: 'app-email-message-section-placeholder',
  imports: [],
  template: `
    <span class="visually-hidden" role="status">Ładowanie formularza wiadomości e-mail...</span>
    <div class="pt-3">
      <div class="placeholder label-placeholder mb-2"></div>
      <div class="placeholder input-placeholder mb-5"></div>
      <div class="placeholder label-placeholder mb-2"></div>
      <div class="placeholder input-placeholder mb-5"></div>
      <div class="placeholder label-placeholder mb-3"></div>
      <div class="placeholder textarea-placeholder mb-5"></div>
      <div class="placeholder checkbox-placeholder mb-5 mt-4"></div>
      <div class="text-center">
        <div class="placeholder button-placeholder"></div>
      </div>
    </div>
  `,
  styleUrl: './email-message-section-placeholder.component.scss'
})
export class EmailMessageSectionPlaceholderComponent {

}
